var pin_r = 8;
var head = 8;
var point_load_arrow_head = 8;
var dist_load_arrow_shaft = 35;
var point_load_arrow_shaft = 60;
var moment_radius = 20;
var dimension_tick = 10;

//highlight element when mouse is over element
function setSelectable(element, unselect_attr, select_attr) {
  element.node.onmouseover =
    function () {
      element.attr(select_attr);
      this.style.cursor = 'pointer';
    };
  element.node.onmouseout =
    function () {
      element.attr(unselect_attr);
    };
}

//hightlight the destination object when the mouse is over hover_elem
function setSelectableTrigger(hover_elem, dest_elem, unselect_attr, select_attr) {
  hover_elem.node.onmouseover =
    function () {
      dest_elem.attr(select_attr);
      this.style.cursor = 'pointer';
    };
  hover_elem.node.onmouseout =
    function () {
      dest_elem.attr(unselect_attr);
    };
}

//hightlight the destination object when the mouse is over a label
function setSelectableLabel(labelElement, destinationElement, unselectAttribute, selectAttribute) {
  labelElement.node.onmouseover = function () {
    destinationElement.attr(selectAttribute);
    this.style.cursor = 'pointer';
    labelElement.attr("fill", "#0d86d7");
  };
  labelElement.node.onmouseout = function () {
    destinationElement.attr(unselectAttribute);
    labelElement.attr("fill", "#000000");
  };
}

function drawBeamSpan(x1, x2, y1, y2, span_attr, span_label, dimension_text, shape, myCanvas, spanIndex) {
  var y = y1;
  var t = y2 - y1;
  var L = x2 - x1;

  var b = myCanvas.rect(x1, y, L, t);
  b.attr(span_attr);
  //when we hover over one beam highlight them all...
  setSelectable(b, span_attr, selected_attr);
  b.node.onclick = function () { openModalShapeDialog(); };
  var top_path_offset = 0;
  var bottom_path_offset = 0;
  if (hasFlanges(shape)) {
    top_path_offset = 4;
    bottom_path_offset = 4;
  }
  if (hasTopFlange(shape)) {
    top_path_offset = 4;
    bottom_path_offset = 0;
  }
  if (hasBottomFlange(shape)) {
    top_path_offset = 0;
    bottom_path_offset = 4;
  }

  var pathStr = pathM(x1, y1 + top_path_offset) + pathL(x2, y1 + top_path_offset) +
    pathM(x2, y2 - bottom_path_offset) + pathL(x1, y2 - bottom_path_offset);
  var p = myCanvas.path(pathStr);
  setSelectableTrigger(p, b, span_attr, selected_attr);
  var c = myCanvas.circle(x1 + L / 2, y + t / 2, t / 3);
  c.attr("fill", "#ffffff");
  setSelectableTrigger(c, b, span_attr, selected_attr);
  c.node.onclick = function () { openModalSpanDialog(spanIndex); };
  var l = myCanvas.text(x1 + L / 2, y + t / 2, span_label);
  l.attr("font-size", "12");
  setSelectableTrigger(l, b, span_attr, selected_attr);
  l.node.onclick = function () { openModalSpanDialog(spanIndex); };
  //draw dimension
  drawSpanDimension(x1, x2, y1, y2, dimension_text, b, myCanvas, spanIndex);
  return [b, p];
}

function drawAddSpanGraphic(x1, x2, y1, y2, span_attr, shape, myCanvas) {
  var y = y1;
  var t = y2 - y1;
  var L = x2 - x1;

  var b = myCanvas.rect(x1, y, L, t);
  b.attr(span_attr);
  //when we hover over the left or right elements highlight them, if clicked add a span
  setSelectable(b, span_attr, selected_attr);
  b.node.onclick = function () { openModalShapeDialog(); };
  var top_path_offset = 0;
  var bottom_path_offset = 0;
  if (hasFlanges(shape)) {
    top_path_offset = 4;
    bottom_path_offset = 4;
  }
  if (hasTopFlange(shape)) {
    top_path_offset = 4;
    bottom_path_offset = 0;
  }
  if (hasBottomFlange(shape)) {
    top_path_offset = 0;
    bottom_path_offset = 4;
  }

  var pathStr = pathM(x1, y1 + top_path_offset) + pathL(x2, y1 + top_path_offset) +
    pathM(x2, y2 - bottom_path_offset) + pathL(x1, y2 - bottom_path_offset);
  var p = myCanvas.path(pathStr);
  setSelectableTrigger(p, b, span_attr, selected_attr);
  var c = myCanvas.circle(x1 + L / 2, y + t / 2, t / 3);
  c.attr("fill", "#ffffff");
  setSelectableTrigger(c, b, span_attr, selected_attr);
  //c.node.onclick = function () { openModalSpanDialog(spanIndex); };
  var l = myCanvas.text(x1 + L / 2, y + t / 2, '+');
  l.attr("font-size", "12");
  setSelectableTrigger(l, b, span_attr, selected_attr);
  l.node.onclick = function () { openModalSpanDialog(spanIndex); };
  
  const r1 = myCanvas.rect(x1 - 1, y - 2, L + 2, t + 4);
  const unselectAttr = {fill: 'rgba(255, 255, 255, 0.8)', 'stroke-width': 0 }
  const selectedAttr = {fill: 'rgba(255, 255, 255, 0.5)', 'stroke-width': 0 }
  r1.attr(unselectAttr);

  setSelectable(r1, unselectAttr, selectedAttr)

  return r1;
}

class Point2 {
  constructor(x, y) {
    this.x = x
    this.y = y
  }
}

class Vector2 {
  constructor(x, y) {
    this.x = x
    this.y = y
  }
  
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y)
  }

  normalize() {
    const l = this.length()
    return new Vector2(this.x / l, this.y / l)
  }
}

function valuesEqual(v1, v2) {
  return Math.abs(v1 - v2) < 1e-9
}

// xs and ys are centerline
function drawBeamSpanResultsView(xs, ys, gradientValues, canvas) {

  const t = 10
  const topPoints = []
  const botPoints = []
  const sections = []
  const angles = []

  const values = gradientValues
  let minVal = 1e9
  let maxVal = -1e9
  values.forEach( value => {
    minVal = Math.min(minVal, value)
    maxVal = Math.max(maxVal, value)
  })

  for (let i = 0; i < xs.length; i++) {
    let i1 = i + 1
    if (i == xs.length - 1) {
      i1 = i - 1
    }

    if(valuesEqual(xs[i], xs[i+1])) {
      continue
    }
    
    const v = new Vector2(xs[i1] - xs[i], ys[i1] - ys[i]).normalize()
    let perp = new Vector2(v.y, -v.x)
    if (i == xs.length - 1) {
      perp.x *= -1
      perp.y *= -1
    }
    topPoints.push(new Point2(xs[i] - perp.x * t, ys[i] - perp.y * t))
    botPoints.push(new Point2(xs[i] + perp.x * t, ys[i] + perp.y * t))
    angles.push(Math.atan2(perp.x, perp.y))
  }

  for (let i = 0; i < topPoints.length - 1; i++) {
    let angleDegrees = angles[i] * 180 / Math.PI

    if(angleDegrees < 0) {
      angleDegrees = 360 + angleDegrees
    }
    
    sections.push({
      topLeft: topPoints[i],
      topRight: topPoints[i+1],
      bottomRight: botPoints[i+1],
      bottomLeft: botPoints[i],
      leftValue: values[i+1],
      rightValue: values[i],
      minValue: minVal,
      maxValue: maxVal,
      startAngleDegrees: angleDegrees
    })
  }

  for (let i = 0; i < sections.length; i++) {
    drawSection(sections[i], canvas)
  }

  var pathStr = pathM(topPoints[0].x, topPoints[0].y)
  for (let i = 0; i < topPoints.length; i++) {
    if (i == 0) { continue; }
    pathStr += pathL(topPoints[i].x, topPoints[i].y)
  }

  for (let i = topPoints.length - 1; i >= 0; i--) {
    pathStr += pathL(botPoints[i].x, botPoints[i].y)
  }

  pathStr += pathL(topPoints[0].x, topPoints[0].y)

  var p = canvas.path(pathStr)
  p.attr("stroke-width", medium_stroke)

}

function drawResultViewLegend(x, y, width, height, minValue, maxValue, canvas) {
  // regular rectangle
  const c = canvas.rect(x, y, width, height);
  c.attr("stroke-width", 1.0)
  c.attr("fill", "90-#Ff0000-#ffff00-#00ff00-#00ffff-#0000ff")

  let pathStr = `${pathM(x, y)}${pathL(x - 8, y)}`
  let p = canvas.path(pathStr)
  p.attr("stroke-width", 1.0)

  pathStr = `${pathM(x, y + height)}${pathL(x - 8, y + height)}`
  p = canvas.path(pathStr)
  p.attr("stroke-width", 1.0)

  // min label
  let textFontSize = 12
  let textBox = renderedTextSize(minValue, textFontSize)
  let l = canvas.text(x - textBox.width * 0.5 - 10, y + height, minValue)
  l.attr("font-size", textFontSize)
  
  // max label
  textBox = renderedTextSize(maxValue, textFontSize)
  l = canvas.text(x - textBox.width * 0.5 - 10, y, maxValue)
  l.attr("font-size", textFontSize)
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function hexForNormalizedValue(valueZeroToOne) {
  const val = valueZeroToOne
  let r = 0, g = 0, b = 0
  if(val <= 0.25) {
    // (0, 0, 255) -> (0, 255, 255)
    const n = val / 0.25
    r = 0
    g = n * 255
    b = 255
  } else if(val <= 0.5 && val > 0.25) {
    // (0, 255, 255) -> (0, 255, 0) 
    const n = (val - 0.25) / 0.25
    r = 0
    g = 255
    b = (1 - n) * 255
  } else if(val <= 0.75 && val > 0.5) {
    // (0, 255, 0) -> (255, 255, 0)
    const n = (val - 0.5) / 0.25
    r = n * 255
    g = 255
    b = 0
  } else if(val > 0.75) {
    // (255, 255, 0) -> (255, 0, 0)
    const n = (val - 0.75) / 0.25
    r = 255
    g = (1 - n) * 255
    b = 0
  }

  return rgbToHex(parseInt(r), parseInt(g), parseInt(b))
}

function drawSection(section, canvas) {
  let pathStr = pathM(section.topLeft.x, section.topLeft.y)
  pathStr += pathL(section.topRight.x, section.topRight.y)
  pathStr += pathL(section.bottomRight.x, section.bottomRight.y)
  pathStr += pathL(section.bottomLeft.x, section.bottomLeft.y)
  pathStr += pathL(section.topLeft.x, section.topLeft.y)

  var p = canvas.path(pathStr)
  p.attr("stroke-width", 0)

  const gradient = getSectionGradient(section)
  p.attr("fill", gradient)

}

// Linear gradient format: “‹angle›-‹colour›[-‹colour›[:‹offset›]]*-‹colour›”, 
// example: “90-#fff-#000” – 90° gradient from white to black or 
//          “0-#fff-#f00:20-#000” – 0° gradient from white via red (at 20%) to black.
function getSectionGradient(section) {

  let maxVal = section.maxValue
  let minVal = section.minValue
  if(Math.abs(minVal) > Math.abs(maxVal)) {
    const v = minVal
    minVal = maxVal
    maxVal = v
  }
  let delta = maxVal - minVal
  let normalizedLeft = (section.leftValue - minVal) / delta
  let normalizedRight = (section.rightValue - minVal) / delta

  const color1 = hexForNormalizedValue(normalizedLeft)
  const color2 = hexForNormalizedValue(normalizedRight)
  let gradient = `${section.startAngleDegrees}-${color1}-${color2}`
  return gradient

}

function drawSpanDimension(x1, x2, y1, y2, label, element, myCanvas, index) {
  var x = x1;
  var y = y1;
  var t = y2 - y1;
  var L = x2 - x1;
  drawLine(x, y + 3.0 * t, x + L, y + 3.0 * t, myCanvas);
  drawLine(x, y + 2.5 * t, x, y + 3.5 * t, myCanvas);
  drawLine(x + L, y + 2.5 * t, x + L, y + 3.5 * t, myCanvas);
  var l = myCanvas.text(x + L / 2, y + 3.5 * t, label);
  l.attr("font-size", "14");
  l.node.onclick = function () { openModalSpanDialog(index); };
  setSelectableLabel(l, element, span_attr, selected_attr)
}

function drawExtremeDimension(x1, x2, y, label, myCanvas) {
  var x = x1
  var L = x2 - x1
  drawLine(x, y, x + L, y, myCanvas)
  drawLine(x, y - 10, x, y + 10, myCanvas)
  drawLine(x + L, y - 10, x + L, y + 10, myCanvas)
  let textFontSize = 12
  let textBox = renderedTextSize(label, textFontSize)
  let textXLoc = x + L / 2
  let labelXOffset = textXLoc - textBox.width * 0.5 < 0 ? textBox.width * 0.5 : 0
  var l = myCanvas.text(textXLoc + labelXOffset, y + 16, label)
  l.attr("font-size", textFontSize)
}

function drawSupport(type, x, y, t, myCanvas, supportIndex) {
  if (type.match(/pinned/)) return drawSimpleSupport(x, y, myCanvas, supportIndex);
  else if (type.match(/fixed/)) return drawFixedSupport(x, y, t, myCanvas, supportIndex);
  else return drawFreeSupport(x, y, t, myCanvas, supportIndex);
}

function addSupportLabel(x, y, myCanvas, supportLabel, supportIndex, supportGraphic) {
  var l = myCanvas.text(x, y + 26, supportLabel)
  l.attr("font-size", "12")
  l.node.onclick = function () { CycleSupport(supportIndex) }
  l.toFront()
  setSelectableLabel(l, supportGraphic, support_attr, selected_attr)
  return l
}

function drawSimpleSupport(x, y, myCanvas, supportIndex) {
  var tri = drawTriangle(pin_r * 2, x, y, myCanvas);
  tri.attr(support_attr);
  setSelectable(tri, support_attr, selected_attr);
  tri.node.onclick = function () { CycleSupport(supportIndex) };
  addSupportLabel(x, y, myCanvas, "Pinned", supportIndex, tri)
  return tri;
}

function drawFreeSupport(x, y, t, myCanvas, supportIndex) {
  var r = myCanvas.rect(x - 0.25 * pin_r, y - t, 0.5 * pin_r, t);
  r.attr(free_support_attr);
  setSelectable(r, free_support_attr, selected_attr);
  r.node.onclick = function () { CycleSupport(supportIndex); };
  addSupportLabel(x, y, myCanvas, "Free", supportIndex, r)
  return r;
}

function drawFixedSupport(x, y, t, myCanvas, supportIndex) {
  var r = myCanvas.rect(x - pin_r, y - pin_r - t, 2 * pin_r, 2 * pin_r + t);
  r.attr(support_attr);
  setSelectable(r, support_attr, selected_attr);
  r.node.onclick = function () { CycleSupport(supportIndex); };
  addSupportLabel(x, y, myCanvas, "Fixed", supportIndex, r)
  return r;
}

function drawPointLoad(x, y, label, myCanvas, index) {
  let a = drawDownArrow(x, y, point_load_arrow_shaft, myCanvas);
  a.attr(point_load_attr);
  setSelectable(a, point_load_attr, { stroke: selected_color });
  a.node.onclick = function () { openPointLoadDialog(index); };
  //our label
  let textFontSize = 12
  let textBox = renderedTextSize(label, textFontSize)
  textBox.width += 20;
  textBox.height *= 1.25;
  // make sure it doesn't get clipped
  if (textBox.height > 114) {
    textFontSize = 10
    textBox = renderedTextSize(label, textFontSize)
  }

  let labelBoxX = x - (textBox.width * 0.5)
  let labelBoxY = y - point_load_arrow_shaft - textBox.height - 12 // add a little padding to offset from arrow
  let textBackgroundRect = myCanvas.rect(labelBoxX, labelBoxY, textBox.width, textBox.height);
  textBackgroundRect.attr(label_rect_attr);

  var l = myCanvas.text(x, y - point_load_arrow_shaft - textBox.height * 0.5 - 12, label);
  l.attr("font-size", textFontSize);
  setSelectableTrigger(l, a, point_load_attr, { stroke: selected_color });
  l.node.onclick = function () { openPointLoadDialog(index); };
  l.toFront();
  return [textBackgroundRect, l];
}

function drawForceReaction(direction, x, y, label, myCanvas) {
  var a = null, l = null;
  if (direction == "up") {
    a = drawUpArrow(x, y + point_load_arrow_shaft + point_load_arrow_head, point_load_arrow_shaft, myCanvas);
    l = myCanvas.text(x, y + point_load_arrow_shaft + head + 12, label);
  } else {
    a = drawDownArrow(x, y - point_load_arrow_head, point_load_arrow_shaft, myCanvas);
    l = myCanvas.text(x, y - point_load_arrow_shaft - head - 12, label);
  }
  a.attr(point_load_attr);
  l.attr("font-size", "12");
  l.toFront();
  return [a, l];
}

function drawMomentLoad(x, y, t, label, myCanvas, index) {
  var a = drawMomentArrow(x, y + t * 0.5, moment_radius, myCanvas);
  a.attr(point_load_attr);
  setSelectable(a, point_load_attr, { stroke: selected_color });
  a.node.onclick = function () { openMomentDialog(index); };

  let textFontSize = 12
  let textBox = renderedTextSize(label, textFontSize)
  textBox.width += 20;
  textBox.height *= 1.25;
  // make sure it doesn't get clipped
  if (textBox.height > 70) {
    textFontSize = 10
    textBox = renderedTextSize(label, textFontSize)
  }

  let labelBoxX = x - textBox.width * 0.5
  let labelBoxY = y + t + moment_radius + 12 // add 12 to avoid overlap with support labels
  let textBackgroundRect = myCanvas.rect(labelBoxX, labelBoxY, textBox.width, textBox.height);
  textBackgroundRect.attr(label_rect_attr);

  var l = myCanvas.text(x, y + t + moment_radius + textBox.height * 0.5 + 12, label);
  l.attr("font-size", textFontSize);
  setSelectableTrigger(l, a, point_load_attr, { stroke: selected_color });
  l.node.onclick = function () { openMomentDialog(index); };
  l.toFront();
  return [textBackgroundRect, l];
}

function drawMomentReaction(x, y, t, label, myCanvas) {
  var a = drawMomentArrow(x, y + t / 2, moment_radius, myCanvas);
  a.attr(point_load_attr);
  var l = myCanvas.text(x + 36, y + t + 24, label);
  l.attr("font-size", "12");
  l.toFront();
  return l;
}

function drawLinearLoad(q1, q2, x1, x2, y1, y2, label, myCanvas, loadIndex) {
  var y = y1;
  var length = dist_load_arrow_shaft;
  var dist = x2 - x1;
  var labelX = x1 + dist / 2;
  var bbox = renderedTextSize(label, "12");
  bbox.width += 20;
  bbox.height *= 1.25;
  // draw at least 3 arrows but no more than 20
  // draw arrows every 12 inches
  var nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3));
  var delta = dist / (nArrows - 1);
  var h1 = length;
  var h2 = length;
  if (Math.abs(q2) > Math.abs(q1)) {
    h2 = length;
    h1 = q1 / q2 * length;
  } else {
    h1 = length;
    h2 = q2 / q1 * length;
  }
  var r = drawTrapazoid(x1, y1, x2, y2, h1, h2, myCanvas);
  r.attr(dist_load_rect_attr);
  setSelectable(r, dist_load_rect_attr, selected_attr);
  r.node.onclick = function () { openLinearLoadDialog(loadIndex); };
  var i = (q1 === 0.0 || q2 === 0.0) ? 1 : 0;
  for (i = 0; i < nArrows; i++) {
    var arrow_length = h1 - (h1 - h2) * i / (nArrows - 1);
    var a = drawDownArrow(x1 + i * delta, y, arrow_length, myCanvas);
    a.attr(dist_load_arrow_attr);
    setSelectableTrigger(a, r, dist_load_rect_attr, selected_attr);
    a.node.onclick = function () { openLinearLoadDialog(loadIndex); };
  }

  //our label
  var labelBoxY = y - length + 4;
  var textBackgroundRect = myCanvas.rect(labelX - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height);
  textBackgroundRect.attr(label_rect_attr);

  var l = myCanvas.text(labelX, labelBoxY + 8, label);
  l.attr("font-size", "12");

  setSelectableTrigger(l, r, dist_load_rect_attr, selected_attr);
  l.node.onclick = function () { openLinearLoadDialog(loadIndex); };
  l.toFront();
  return [textBackgroundRect, l];
}


function drawDistributedLoad(direction, x1, x2, y1, label, myCanvas, loadIndex) {
  var y = y1;
  var length = dist_load_arrow_shaft;
  var dist = x2 - x1;
  var nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3));
  var delta = dist / (nArrows - 1);
  var r = myCanvas.rect(x1, y - length, dist, length);
  r.attr(dist_load_rect_attr);
  //r.attr(label_rect_attr);
  setSelectable(r, dist_load_rect_attr, selected_attr);
  r.node.onclick = function () { openUniformLoadDialog(loadIndex); };
  for (var i = 0; i < nArrows; i++) {
    var a = null;
    if (direction === "up") a = drawUpArrow(x1 + i * delta, y, length, myCanvas);
    else a = drawDownArrow(x1 + i * delta, y, length, myCanvas);
    a.attr(dist_load_arrow_attr);
    setSelectableTrigger(a, r, dist_load_rect_attr, selected_attr);
    a.node.onclick = function () { openUniformLoadDialog(loadIndex); };
  }

  //our label
  var bbox = renderedTextSize(label, "12");
  bbox.width += 20;
  bbox.height *= 1.25;

  var labelBoxY = y - length + 6;

  var textBackgroundRect = myCanvas.rect(x1 + dist / 2 - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height);
  textBackgroundRect.attr(label_rect_attr);

  var l = myCanvas.text(x1 + dist / 2, labelBoxY + 10, label);
  l.attr("font-size", "12");
  setSelectableTrigger(l, r, dist_load_rect_attr, selected_attr);
  l.node.onclick = function () { openUniformLoadDialog(loadIndex); };
  l.toFront();
  return [textBackgroundRect, l];
}


function drawCrossSection(shapeData, crossSectionRotation, myCanvas) {
  // draw at upper right

  const selectedAttr = {fill: "#ffff99" }

  var plys = 1;
  if (activeProject.isEngineeredLumber) {
    plys = activeProject.numberOfPlys;
  } else if (activeProject.isWood) {
    // parse number off front of name
    var tokens = activeProject.shape["Name"].split("-");
    if (tokens.length === 2) {
      plys = parseInt(tokens[0]);
    }
  }

  var text = shapeName(shapeData);
  if (activeProject.isEngineeredLumber || activeProject.isWood) {
    text += " - " + plys.toString() + " plys";
  }
  var textSize = renderedTextSize(text, 12);
  var frameWidth = textSize.width + 30;
  var frameHeight = 70;

  // draw frame first
  //upper right corner of canvas
  var r = myCanvas.rect(1, 1, frameWidth, frameHeight, 2);
  r.attr({ stroke: "#B8B8B8", fill: "#ffffff" });
  setSelectable(r, { stroke: "#B8B8B8", fill: "#ffffff" }, selectedAttr);
  r.node.onclick = function () { openModalShapeDialog(); };

  var l = myCanvas.text(frameWidth * 0.5, frameHeight - 15, text);
  l.attr("font-size", "12", "stroke", "#808080");
  setSelectableTrigger(l, r, { stroke: "#B8B8B8", fill: "#ffffff" }, selectedAttr);
  l.node.onclick = function () { openModalShapeDialog(); };

  var b = 20;
  var d = 30;
  var t = 3;

  // steel shape
  if (isSteelShape(shapeData)) {
    if (isHssRoundShape(shapeData)) {
      var r = d * 0.5;
      var p = drawPipeShape(r, t, myCanvas);
      p.translate(frameWidth * 0.5, 10 + r);
      p.attr({ stroke: "#b34332", 'stroke-width': 4 });
      setSelectableTrigger(p, r, { stroke: "#b34332", 'stroke-width': 4 }, selectedAttr);
      p.node.onclick = function () { openModalShapeDialog(); };
      return;
    }
    if (isIShape(shapeData)) {
      var p = drawIShape(b, d, t, myCanvas);
    } else if (isTShape(shapeData)) {
      var p = drawTShape(b, d, t, myCanvas);
    } else if (isCShape(shapeData)) {
      var p = drawCShape(b, d, t, myCanvas);
    } else if (isLShape(shapeData)) {
      var p = drawLShape(b, d, t, myCanvas);
    } else if (isHssRectangleShape(shapeData)) {
      var p = drawHSSShape(b, d, t, myCanvas);
    } else if (isHssSquareShape(shapeData)) {
      b = d;
      var p = drawHSSShape(b, d, t, myCanvas);
    } else {
      var p = myCanvas.rect(0, 0, b, d, 1);
    }
    p.translate(frameWidth * 0.5 - b * 0.5, 10);
    p.rotate(crossSectionRotation);
    p.attr({ stroke: "#808080", fill: "#b34332" });
    //background-color: #ffff99;
    //{stroke: "#808080", fill: "#ffff99" }
    setSelectableTrigger(p, r, { stroke: "#808080", fill: "#b34332" }, selectedAttr);
    p.node.onclick = function () { openModalShapeDialog(); };
    return;
  }

  if (plys === 1) {
    b = 5;
  }

  var fill = isWoodShape(shapeData) || isEngineeredLumber(shapeData) ? "#FCF881" : "#00BFFF";
  var st = myCanvas.set();
  var x = 0;
  var b1 = b / plys;
  for (var i = 0; i < plys; i++) {
    var rect = myCanvas.rect(x, 0, b1, d, 1);
    rect.attr({ stroke: "#808080", fill: fill });
    setSelectableTrigger(rect, r, { stroke: "#808080", fill: "#FCF881" }, selectedAttr);
    rect.node.onclick = function () { openModalShapeDialog(); };
    st.push(rect);
    x += b1;
  }
  st.translate(frameWidth * 0.5 - b * 0.5, 10);
  st.rotate(crossSectionRotation);
  st.attr({ stroke: "#808080", fill: fill });
}

function renderedTextSize(string, fontSize) {
  var paper = Raphael(0, 0, 0, 0);
  paper.canvas.style.visibility = 'hidden';

  var el = paper.text(0, 0, string);
  el.attr('font-size', fontSize);

  var bBox = el.getBBox();
  paper.remove();

  return {
    width: bBox.width,
    height: bBox.height
  };
}

function pathM(x, y) { return " M " + x + " " + y + " "; }

function pathL(x, y) { return " L " + x + " " + y + " "; }

function drawLine(x1, y1, x2, y2, myCanvas) {
  var pathStr = pathM(x1, y1) + pathL(x2, y2);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawHorizontalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas) {
  var half_tick = parseInt(head_size * 0.5);
  var pathStr = pathM(x1 + half_tick, y1 - half_tick);
  pathStr += pathL(x1, y1);
  pathStr += pathL(x1 + half_tick, y1 + half_tick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 - half_tick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 + half_tick);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawVerticalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas) {
  var half_tick = parseInt(head_size * 0.5);
  var pathStr = pathM(x1 - half_tick, y1 + half_tick);
  pathStr += pathL(x1, y1);
  pathStr += pathL(x1 + half_tick, y1 + half_tick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 - half_tick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 + half_tick, y2 - half_tick);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawMomentArrow(x, y, r, myCanvas) {
  var n_section = 15;
  var theta = 1.5 * 3.14159625 / n_section;
  var pathStr = pathM(0, r);
  var xr = 0;
  var yr = 0;
  for (var i = 0; i < n_section + 1; i++) {
    xr = r * Number(Math.sin(i * theta));
    yr = r * Number(Math.cos(i * theta));
    pathStr += pathL(xr, yr);
  }
  pathStr += pathL(xr - head / 2, yr);
  pathStr += pathL(xr, yr + head);
  pathStr += pathL(xr + head / 2, yr);
  pathStr += pathL(xr, yr);
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}

function drawTriangle(size, x, y, myCanvas) {
  //M 0 size L size size L size/2 0 L 0 size z
  var pathStr = pathM(0, size) + pathL(size, size) + pathL(size / 2, 0) + pathL(0, size) + " z";
  var p = myCanvas.path(pathStr);
  p.translate(x - size / 2, y);
  return p;
}

function drawTrapazoid(x1, y1, x2, y2, q1, q2, myCanvas) {
  var pathStr = pathM(x1, y1 - q1) + pathL(x1, y1) + pathL(x2, y2) + pathL(x2, y2 - q2) + " z";
  var p = myCanvas.path(pathStr);
  return p;
}

function drawDownArrow(x, y, length, myCanvas) {
  // don't draw arrow head
  var pathStr = pathM(-head / 3, -head) + pathL(0, 0) + pathL(head / 3, -head) + pathL(0, 0) + pathL(0, -length);
  if (length < head * 1.2) {
    pathStr = pathM(0, 0) + pathL(0, -length);
  }
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}

function drawUpArrow(x, y, length, myCanvas) {
  var pathStr = pathM(-head / 3, -length + head) + pathL(0, -length) + pathL(head / 3, -length + head) + pathL(0, -length) + pathL(0, 0);
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}

function drawBrace(x, y, size, myCanvas) {
  var c = myCanvas.circle(x, y, size);
  c.attr(support_attr);
  setSelectable(c, support_attr, selected_attr);
  c.node.onclick = function () { OpenBracingWidget(); };
  var l = myCanvas.text(x, y, "X");
  l.attr("font-size", "12");
  setSelectableTrigger(l, c, support_attr, selected_attr);
  l.node.onclick = function () { openModalBracingDialog(); };
  l.toFront();
  var st = myCanvas.set();
  st.push(c, l);
  return st;
  //return c;
}

//shapes
function drawIShape(b, d, t, canvas) {
  //upper right corner of canvas
  var pathStr = pathM(0, 0);
  pathStr += pathL(0, t);
  pathStr += pathL(b / 2 - t / 2, t);
  pathStr += pathL(b / 2 - t / 2, d - t);
  pathStr += pathL(0, d - t);
  pathStr += pathL(0, d);
  pathStr += pathL(b, d);
  pathStr += pathL(b, d - t);
  pathStr += pathL(b / 2 + t / 2, d - t);
  pathStr += pathL(b / 2 + t / 2, t);
  pathStr += pathL(b, t);
  pathStr += pathL(b, 0);
  pathStr += " z";
  var p = canvas.path(pathStr);
  return p;
}

function drawTShape(b, d, t, canvas) {
  //upper right corner of canvas
  var pathStr = pathM(0, 0);
  pathStr += pathL(0, t);
  pathStr += pathL(b / 2 - t / 2, t);
  pathStr += pathL(b / 2 - t / 2, d - t);
  pathStr += pathL(b / 2 + t / 2, d - t);
  pathStr += pathL(b / 2 + t / 2, t);
  pathStr += pathL(b, t);
  pathStr += pathL(b, 0);
  pathStr += " z";
  var p = canvas.path(pathStr);
  return p;
}

function drawCShape(b, d, t, canvas) {
  //upper right corner of canvas
  var pathStr = pathM(0, 0);
  pathStr += pathL(0, d);
  pathStr += pathL(b, d);
  pathStr += pathL(b, d - t);
  pathStr += pathL(t, d - t);
  pathStr += pathL(t, t);
  pathStr += pathL(b, t);
  pathStr += pathL(b, 0);
  pathStr += " z";
  var p = canvas.path(pathStr);
  return p;
}

function drawLShape(b, d, t, canvas) {
  //upper right corner of canvas
  var pathStr = pathM(0, 0);
  pathStr += pathL(0, d);
  pathStr += pathL(b, d);
  pathStr += pathL(b, d - t);
  pathStr += pathL(t, d - t);
  pathStr += pathL(t, 0);
  pathStr += " z";
  var p = canvas.path(pathStr);
  return p;
}

function drawHSSShape(b, d, t, canvas) {
  //upper right corner of canvas
  var pathStr = pathM(0, 0);
  pathStr += pathL(0, d);
  pathStr += pathL(b, d);
  pathStr += pathL(b, 0);
  pathStr += "z";
  pathStr += pathM(t, t);
  pathStr += pathL(b - t, t);
  pathStr += pathL(b - t, d - t);
  pathStr += pathL(t, d - t);
  pathStr += " z";
  var p = canvas.path(pathStr);
  return p;
}

function drawPipeShape(r, t, canvas) {
  return canvas.circle(0, 0, r);
}
